import AdminFacilityBlock from "../../components/personal/AdminSettingsPage/AdminFacilities/AdminFacilityBlock";
import MainNavbar from "../../components/reuse/MainNavbar";
import PersonDropdown from "../../components/reuse/PersonDropdown";
import { TypicalPageStructure } from "../../components/reuse/TypicalPageStructure";

const AdminFacilities = () => {
    return(
        <>
        <TypicalPageStructure pageLabel={"Предприятия"}>
            <AdminFacilityBlock/>
        </TypicalPageStructure>
        </>
    )
}
export default AdminFacilities;